import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import AuthContext from '../context/AuthContext';

const RequireAuth = () => {
    const location = useLocation();
    const { isAuthenticated } = useContext(AuthContext) || {}; 

    return (
        isAuthenticated 
            ? <Outlet /> 
            : <Navigate to="/" state={{ from: location }} replace />
    );
};

export default RequireAuth;
